import { makeStyles, Box } from '@material-ui/core';
import {
  TERMINAL_TEAM_LOGO,
} from 'utils/constants';

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: '10%',
    clipPath: `url(#clip-path)`,
    overflow: 'hidden',
    background: (props) => `url(${props.imageUrl || '#'})`,
    backgroundSize: 'cover !important',
  },
});

const FullScreen = ({ imageUrl }) => {
  const classes = useStyles({ imageUrl });

  return (
    <div className={classes.root}>
      {imageUrl ? null : (
        <>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            height="100%"
          >
            <img src={TERMINAL_TEAM_LOGO} width="100%" />
          </Box>
        </>
      )}
    </div>
  );
};

export default FullScreen;
